import { render } from "./OrderRejectDialog.vue?vue&type=template&id=6af785fb"
import script from "./OrderRejectDialog.vue?vue&type=script&lang=js"
export * from "./OrderRejectDialog.vue?vue&type=script&lang=js"

import "./OrderRejectDialog.vue?vue&type=style&index=0&id=6af785fb&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/OrderRejectDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6af785fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6af785fb', __exports__)) {
    console.log('reload')
    api.reload('6af785fb', __exports__)
  }
  
  module.hot.accept("./OrderRejectDialog.vue?vue&type=template&id=6af785fb", () => {
    console.log('re-render')
    api.rerender('6af785fb', render)
  })

}


export default __exports__